const styles = theme => ({
  container: {
    lineHeight: 2,
    textAlign: 'justify',
    "& h2": {
      fontWeight: "600",
      marginBottom: 10
    },

    "& img": {
      margin: " 20px auto",
      display: "block",
      maxHeight: 500
    }
  },
  desc: {
    fontWeight: "500"
  }
});

export default styles;
